
import { styled } from '@mui/material';
import ring from "../../../../../shared/assets/img/hero/ring.png";
//import heart from "../../../../../shared/assets/heart.svg";
import heart from "../../../../../shared/assets/img/front-view-hands-showing-heart-sign.jpg";
import mobileRing from "../../../../../shared/assets/img/hero/mobile.png";

export const StyledHero = styled('section')`
  margin-top: -90px;
  padding: 100px 0 100px;
  background-image: url(${heart});
  background-repeat: no-repeat;
  background-position: center top;
  background-size: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f7f7f7;
  background-size: cover;
  border-bottom: 1px solid #d4d4d4;

  @media (max-width: 768px) {
    background-image: url(${heart});
    padding: 100px 0 100px 0;
    background-position: center 50px;
    background-size: cover;
  }
  @media (max-width: 680px) {
    padding: 90px 0 50px 0;
  }
`;

export const ContentWrapper = styled('div')`
  margin-top: 0;
  display: flex;
  padding: 0 15px;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media (max-width: 540px) {
    margin-top: 20px;
    margin-bottom: 0;
  }

  @keyframes fadeInFromTop {
    from {
      opacity: 0;
      transform: translateY(-50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h1 {
    font-size: 48px;
    font-weight: 500;
    line-height: 52.8px;
    text-align: center;
    font-family: "YesevaOne", serif;
    color: #2B2B2B;
    opacity: 0;
    transform: translateY(-50px);
    animation: fadeInFromTop 1s ease-out forwards;

    @media (max-width: 768px) {
      font-size: 32px;
      line-height: 40.8px;
    }
    @media (max-width: 530px) {
      font-size: 25px;
      line-height: 30.8px;
    }
  }

  p {
    margin-top: 12px;
    font-family: "CormorantInfant", serif;
    font-size: 24px;
    font-weight: 400;
    color: #2B2B2B;
    text-align: center;
    line-height: 1.1;
    opacity: 0;
    transform: translateY(-50px);
    animation: fadeInFromTop 1s ease-out forwards;
    animation-delay: 0.5s;

      @media (max-width: 680px) {
        font-size: 18px;
      }
  }

  button {
    padding: 17px 60px 17px 40px;
    margin-top: 24px;
    border: 2px solid #2DB3F6;
    box-shadow: 0px 0px 16px -2px rgba(45, 179, 246, 0.6);
    color: #2DB3F6;
    font-size: 18px;
    font-weight: 700;
    border-radius: 63px;
    background: transparent;
    font-family: "Montserrat", sans-serif;
    transition: background 0.3s ease;
    opacity: 0;
    transform: translateY(-50px);
    animation: fadeInFromTop 1s ease-out forwards;
    animation-delay: 1s;

    &:hover {
      background: #fff;
      border-color: transparent;
      color: #000;
      cursor: pointer;
    }
    @media (max-width: 680px) {
        margin-top: 15px;
        font-size: 16px;
    }
  }
`;
